/* global VXConfig */
'use strict';

import Flux from '../Flux';

class FooterLinksStore {
	static getSocialLinks() {
		const instagramLink = 'https://www.instagram.com/visitxworld';
		const youtubeLink = 'https://www.youtube.com/channel/UCalMC3-L8DWxknoXMC0M-uQ';
		const twitterLink = 'https://x.com/VisitX_World';
		return {
			instagram: instagramLink,
			youtube: youtubeLink,
			twitter: twitterLink,
		};
	}

	static getSocialIcons() {
		return {
			instagram: '-icon-social-instagram',
			youtube: '-icon-youtube-full',
			twitter: '-icon-social-twitter-x',
		};
	}

	static getZendeskLink(language) {
		let zendesk = 'https://visitxbv.zendesk.com/hc/';
		switch (language.toUpperCase()) {
			case Flux.Constants.Languages.DE.toUpperCase():
				zendesk += 'de';
				break;
			case Flux.Constants.Languages.ES.toUpperCase():
				zendesk += 'es';
				break;
			default:
				zendesk += 'en-us';
		}
		zendesk += Flux.Guest.isLoggedIn() ? '?name=' + encodeURIComponent(Flux.Guest.getName()) : '';
		return zendesk;
	}

	static getVxModelsLink(language) {
		return `https://www.vxmodels.com/${language.toUpperCase() !== Flux.Constants.Languages.DE.toUpperCase() ? 'en/' : ''}?pfmr=1502`;
	}

	static getBecomeAVisitXModelLink(language) {
		return Flux.Browser.isSexole() ? 'https://infowebcam.com/' : FooterLinksStore.getVxModelsLink(language);
	}

	static getVxCashLink() {
		return (
			'https://www.vxcash.net/?rid=0&pfm=' + Flux.VXMobile.getPlatform() + '&w=' + VXConfig.wmId + '&ws=' + VXConfig.wmSubref + '&track=Index'
		);
	}

	static getReportContentLink(language) {
		let reportContentLink = 'https://support.visit-x.net/hc/en-us/requests/new?tf_28097877372818=dsa';
		switch (language.toUpperCase()) {
			case Flux.Constants.Languages.DE.toUpperCase():
				reportContentLink = 'https://support.visit-x.net/hc/de/requests/new?tf_28097877372818=dsa';
				break;
			case Flux.Constants.Languages.ES.toUpperCase():
				reportContentLink = 'https://support.visit-x.net/hc/es/requests/new?tf_28097877372818=dsa';
				break;
		}
		reportContentLink += Flux.Guest.isLoggedIn() ? '&name=' + encodeURIComponent(Flux.Guest.getName()) : '';
		return reportContentLink;
	}
}

export default FooterLinksStore;
